import React from 'react'
import Main from '../../../../components/HOC/Main'
import { NAVIGATION } from '../../../../lib/navigation'
import { useLocation } from 'react-router-dom'
import TeamMemberForm from '../../../../components/pages/TeamMemberForm'

const EditTeamMemberPage = () => {
    const location = useLocation();
    const { teamMemberData } = location.state || {};
    return (
        <Main crumbs={[{ title: "masters" }, { title: "team members", href: NAVIGATION.INNER_NAVIGATION.MASTERS.TEAM_MEMBERS }, { title: "update team member" }]}>
            <TeamMemberForm defaultData={teamMemberData} />
        </Main>
    )
}

export default EditTeamMemberPage